export default "__VITE_ASSET__BDQNw8mf__"